import { BoxProps, SystemStyleObject, TextProps } from '@chakra-ui/react';

export const linkHoverStyleProps = (
    hoverProps: SystemStyleObject = {}
): TextProps => ({
    transition: 'all',
    transitionDuration: '200ms',
    _hover: {
        color: 'blue.400',
        transition: 'all',
        transitionDuration: '200ms',
        cursor: 'pointer',
        ...hoverProps,
    },
});

export const hoverStyleProps = (
    hoverProps: SystemStyleObject
): Pick<BoxProps, 'transition' | '_hover'> => ({
    transition: '200ms all',
    _hover: {
        transition: 'all',
        transitionDuration: '200ms',
        cursor: 'pointer',
        ...hoverProps,
    },
});

export const groupHoverStyleProps = (
    hoverProps: SystemStyleObject
): Pick<BoxProps, '_groupHover'> => ({
    _groupHover: {
        transition: 'all',
        transitionDuration: '200ms',
        cursor: 'pointer',
        ...hoverProps,
    },
});

export const disabledStyleProps = (
    isDisabled: boolean,
    disabledProps: BoxProps = {}
): BoxProps => ({
    transition: 'all',
    transitionDuration: '200ms',
    opacity: isDisabled ? 0.5 : 1,
    pointerEvents: isDisabled ? 'none' : undefined,
    ...(isDisabled ? disabledProps : {}),
});

export const scrollShadowStyle = () => ({
    // Show bottom shadow ONLY when there is more content
    // Ref: https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
    background: `
        /* Shadow Cover BOTTOM */
        linear-gradient(
        rgba(255, 255, 255, 0),
        white 70%
        ) center bottom,
        /* Shadow BOTTOM */
        linear-gradient(
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.1)
        ) center bottom`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 80px, 100% 20px',
    backgroundAttachment: 'local, scroll',
});
